<!-- /**
* 工队详情页面
* @authors zzt
* @date 2019/1/28
* @version 1.0
*/ -->
<template>
  <div class="talents">
    <div class="talents_details">
      <Breadcrumb :breadcrumbName="breadcrumbObj"></Breadcrumb>
      <div class="talents_details_content">
        <div class="talents_details_content_left">
          <div class="titleTop">
            <div class="left">报价详情</div>
            <div class="right" @click="goBack">返回报价列表</div>
          </div>
          <div class="equInfoDeatils">
            <div class="equInfoDeatils_Content">
              <!-- <div class="titleText">{{PriseDetails.teamName}}</div> -->
              <div class="itemBox">
                <div>
                  工程分类：
                  <span> {{ PriseDetails.firstCategoryName }}</span>
                </div>
                <div>
                  专业分类：
                  <span> {{ PriseDetails.secondCategoryName }}</span>
                </div>
              </div>
              <div class="itemBox">
                <div>
                  工程类型：
                  <span> {{ PriseDetails.thirdCategoryName }}</span>
                </div>
              </div>
              <div class="itemBox">
                <!-- <div>工程类型：
                  <span> {{PriseDetails.thirdCategoryName}}</span>
                </div> -->
                <div>
                  工种名称：
                  <span> {{ PriseDetails.typeWork }}</span>
                </div>
                <div>
                  计量单位：
                  <span> {{ PriseDetails.unit }}</span>
                </div>
              </div>
              <div class="itemBox">
                <!-- <div>计量单位：
                  <span> {{PriseDetails.unit}}</span>
                </div> -->
                <div>
                  包含材料： <span> {{ PriseDetails.material }}</span>
                </div>
                <div>
                  包含材料单价：
                  <span> {{ PriseDetails.priceWithMaterial }}</span>
                </div>
              </div>
              <div class="itemBox">
                <!-- <div>包含材料单价： <span> {{PriseDetails.priceWithMaterial}}</span>
                </div> -->
                <div>
                  不包含材料单价：
                  <span> {{ PriseDetails.price }}</span>
                </div>
                <div>
                  报价单位：
                  <span> {{ PriseDetails.teamName }}</span>
                </div>
              </div>
              <!-- <div class="itemBox">
                <div>报价单位：
                  <span> {{PriseDetails.teamName}}</span>
                </div>
              </div> -->
              <div class="itemBox">
                <div>
                  包含设备：
                  <!-- <span> {{PriseDetails.equipment}}</span> -->
                  <span
                    style="white-space: pre-wrap;"
                    v-if="PriseDetails.equipment"
                    v-html="PriseDetails.equipment"
                  >
                  </span>
                </div>
              </div>
              <div class="itemBox">
                <div>
                  报价原则：
                  <!-- <span> {{PriseDetails.principle}}</span> -->
                  <span
                    style="white-space: pre-wrap;"
                    v-if="PriseDetails.principle"
                    v-html="PriseDetails.principle"
                  >
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="talents_details_content_right">
          <div v-if="messageData.isCompany == 0" class="PersonMessage">
            <div class="name">
              <el-tooltip
                popper-class="changeTootip"
                effect="light"
                :visible-arrow="false"
                :content="messageData.teamName"
                placement="bottom"
                :offset="10"
              >
                <div class="describe">{{ messageData.teamName }}</div>
              </el-tooltip>
              <!-- <span class="text">{{messageData.teamName}}</span> -->
              <span class="icon">个体</span>
            </div>
            <div class="imgIcon">
              <img src="@/assets/redesignImg/person.png" alt="" />
              <img src="@/assets/redesignImg/phone.png" alt="" />
            </div>
            <div class="item">联系人：{{ messageData.contact }}</div>
            <div class="item">
              联系电话：
              <span v-if="showpNumber">
                {{ messageData.phoneNumber }}
              </span>
              <span v-else>
                {{ ShowPhone(messageData.phoneNumber) }}
              </span>
              <span
                class="showText"
                v-if="!showpNumber"
                @click="ShowPhoneNumber"
              >
                查看完整号码
              </span>
            </div>
            <div class="box" @click="OnlineConsulting">
              <img src="@/assets/redesignImg/msg.png" alt="" />
              在线咨询
            </div>
          </div>
          <div v-else-if="messageData.isCompany == 1" class="EnterpriseMessage">
            <div class="name">
              <el-tooltip
                popper-class="changeTootip"
                effect="light"
                :visible-arrow="false"
                :content="messageData.teamName"
                placement="bottom"
                :offset="10"
              >
                <div class="describe">{{ messageData.teamName }}</div>
              </el-tooltip>
              <!-- <span class="text">{{messageData.teamName}}</span> -->
              <span class="icon">企业</span>
            </div>
            <div class="imgIcon">
              <img src="@/assets/redesignImg/person.png" alt="" />
              <img src="@/assets/redesignImg/phone.png" alt="" />
              <img src="@/assets/redesignImg/ern.png" alt="" />
              <img src="@/assets/redesignImg/shophome.png" alt="" />
            </div>
            <div class="item">联系人：{{ messageData.contact }}</div>
            <div class="item">
              联系电话：
              <span v-if="showpNumber">
                {{ messageData.phoneNumber }}
              </span>
              <span v-else>
                {{ ShowPhone(messageData.phoneNumber) }}
              </span>

              <span
                class="showText"
                v-if="!showpNumber"
                @click="ShowPhoneNumber"
              >
                查看完整号码
              </span>
            </div>
            <div class="footer">
              <div class="textLeft" @click="enterpriseWeb">
                企业网站
              </div>
              <div class="box" @click="OnlineConsulting">
                <img src="@/assets/redesignImg/msg.png" alt="" />
                在线咨询
              </div>
            </div>
          </div>
          <div class="ImgContent">
            <img src="@/assets/redesignImg/adver.png" alt="" />
          </div>
          <div class="dataList">
            <div class="title">
              <div class="name">相关报价推荐</div>
              <div class="more" @click="More">查看更多</div>
            </div>
            <div class="itemList" v-if="newSettledListData.length > 0">
              <div
                class="item"
                v-for="(item, index) in newSettledListData"
                :key="index"
              >
                <div class="top">
                  <div
                    class="title"
                    style="color: #0286df !important;"
                    @click="GoDetila(item)"
                  >
                    {{ item.teamName }}
                  </div>
                  <!-- <div class="address">
                    浏览数：{{ Math.floor(Math.random() * 1000 + 1)}}人
                  </div> -->
                </div>
                <div class="bottom">
                  <div class="type">
                    工队分类：
                    <span>
                      <el-tooltip
                        popper-class="changeTootip"
                        effect="light"
                        :visible-arrow="false"
                        :content="ChangeString(item)"
                        placement="bottom"
                        :offset="30"
                      >
                        <div style="display: inline">
                          {{ ChangeString(item) }}
                        </div>
                      </el-tooltip>
                    </span>
                  </div>
                  <div class="type">
                    包含材料：
                    <span> {{ item.material }}</span>
                  </div>
                  <div class="type">
                    包含材料单价：
                    <span> {{ item.priceWithMaterial }}</span>
                  </div>
                  <!-- <div class="business">
                    主营业务：
                    <span>
                      <el-tooltip
                        popper-class="changeTootip"
                        effect="light"
                        :visible-arrow='false'
                        :content="ChangeToString(item.businessScopes,'left')"
                        placement="bottom"
                        :offset='30'
                      >
                        <div style="display: inline"> {{ChangeToString(item.businessScopes,'left')}} </div>
                      </el-tooltip>

                    </span>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="noList" v-else>
              <!-- 暂无数据 -->
            </div>
            <!-- <div class="more">
              查看更多>>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import link from "@/public/link.js"
import { formatDate2, formatDate } from "@/filters"

import { apiResignAll } from "@/api/apiResignAll"
import localStorage from "@/storage/localStorage"
export default {
  name: "ConstructionDetails",
  props: {},
  data() {
    return {
      ShowMoreText: true,
      isHtml: false,
      PriseDetails: {},

      teamSizeOption: [],

      showpNumber: false,
      // 当前标志
      InfoNo: null,
      // 主题信息
      UserInfo: {},
      // 详情信息
      messageData: {
        besinessScope: "",
        contact: "",
        id: 3,
        no: "",
        phoneNumber: "",
        serviceArea: "",
        teamIntroduce: "",
        teamName: "",
        teamSize: 0,
        teamStatus: null,
        companyId: null
      },

      checkIndex: 0,
      phone: "",
      title: {
        name: "",
        updateTime: null
      },
      breadcrumbObj: {
        title: "当前位置：",
        fristName: "首页",
        fristPath: "/",
        secondName: "工队列表",
        secondPath: "/teamList",
        threeName: "业绩详情"
      },

      constructionTeamData: {},
      teamTypeData: [],
      teamSkillsData: [],
      rollScroll: false,
      // 视频相册
      CertList: [],
      VideoParam: {
        page: 1,
        limit: 20
      },

      CertloadingTrue: false,
      CertnoTextData: false,
      CertParam: {
        page: 1,
        limit: 20
      },
      newSettledListData: [],
      noPrise: null
    }
  },
  computed: {},
  components: {
    // Title: () => import('@/components/details/Title'),
    Breadcrumb: () => import("@/components/public/RedesignBreadcrumb")
  },

  created() {
    const DetailsIndexKey = localStorage.read("DetailsIndexKey")
    if (DetailsIndexKey === 1) {
      //
      this.breadcrumbObj = {
        title: "当前位置：",
        fristName: "首页",
        fristPath: "/",
        secondName: "工队列表",
        secondPath: "/teamList",
        threeName: "工队详情 / 报价详情"
      }
    } else if (DetailsIndexKey === 2) {
      this.breadcrumbObj = {
        title: "当前位置：",
        fristName: "首页",
        fristPath: "/",
        secondName: "需求大厅",
        secondPath: "/demandHall",
        threeName: "工队详情 / 报价详情"
      }
    } else if (DetailsIndexKey === 3) {
      this.breadcrumbObj = {
        title: "当前位置：",
        fristName: "首页",
        fristPath: "/",
        secondName: "工队报价",
        secondPath: "/volunteerTeamOffer",
        threeName: " 报价详情"
      }
    }
    const id = this.$route.params.id ? this.$route.params.id : null
    this.noPrise = this.$route.params.no ? this.$route.params.no : null
    if (id) {
      this.TeamInfoDetail(id)
    }
    this.PriseInfoDetail(this.noPrise)
    // this.PriseDetails = sessionStorage.read("PriseDetails")
    //   ? JSON.parse(sessionStorage.read("PriseDetails"))
    //   : {};
    // const id = sessionStorage.read("equNo");
    // if (id) {
    //   this.TeamInfoDetail(id);
    // } else {
    // }
    this.getteamSizeOption()
  },
  methods: {
    // 时间格式转化
    timeToString(timestamp) {
      const d = new Date(timestamp * 1000) // 根据时间戳生成的时间对象
      const date =
        d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()
      return date
    },
    // 返回
    goBack() {
      this.$router.push("/volunteerTeamOffer")
      // this.$router.go(-1);
    },
    // 企业网站
    enterpriseWeb() {
      window.open(
        process.env.VUE_APP_MATERIALSURL +
          "/#/company/" +
          this.messageData.companyId,
        "_blank"
      )
    },
    GoDetila(list) {
      // this.$router.push({ path: `/RedesignDetailsPrise/${id}` });
      this.$router.push({
        path: `/RedesignDetailsPrise/${list.teamNo}/${list.no}`
      })
      location.reload()

      // sessionStorage.save("equNo", list.no);
      // sessionStorage.save("PriseDetails", JSON.stringify(list));
      // this.$router.push({ path: `/RedesignTeamDetailsPrise` });
    },
    // 获取视频相册
    async GetfindAlbumByTeamNo(data) {
      let res = await apiResignAll.GetfindAlbumByTeamNo(data)
      //
      //
      //
      this.CertList = res.data.data
      // this.loadingTrue = false;
    },
    // 地址
    ChangeAddress(data) {
      var array = []
      if (data) {
        const objArray = JSON.parse(data) ? JSON.parse(data) : []
        //

        objArray.map(item => {
          array.push(item.name)
        })
      }
      //
      const string = array.join(",")
      return string
    },
    // 报价分页
    offergetPage() {
      this.getTeamOffer(this.offerParam)
    },
    // 设备分页
    equgetTeam() {
      this.teamDetailEquipmentList(this.equParam)
    },
    // typeString
    ChangeString(data) {
      const stringF = data.firstCategoryName ? data.firstCategoryName : ""
      const stringS = data.secondCategoryName
        ? `/${data.secondCategoryName}`
        : ""
      const stringT = data.thirdCategoryName ? `/${data.thirdCategoryName}` : ""
      return `${stringF} ${stringS}${stringT} `
    },
    // 业绩分页
    getTeamperformance() {
      this.getTeamResults(this.performanceParam)
    },
    // 人员分页
    getTeamPersonPage() {
      this.getTeamPerson(this.performanceParamPerson)
    },
    // 获得推荐列表
    async newSettledList(id, no) {
      const obj = {
        id,
        no
      }
      let res = await apiResignAll.PriserecommendList(obj)

      if (res && res.data && res.data.code === 200) {
        this.newSettledListData = res.data.data.slice(0, 3)
      }
    },
    // 查看更多
    More() {
      // this.$store.commit("SET_INDEXKEY", 1);
      // localStorage.set("indexKey", 1);
      this.$router.push("/volunteerTeamOffer")
    },
    // 联系号码
    ShowPhone(phone) {
      if (phone && phone.length === 11) {
        const number = `${phone.slice(0, 3)}****${phone.slice(7, 11)}`
        return number
      }
    },

    // 获得团队规模
    async getteamSizeOption() {
      let res = await apiResignAll.getteamSizeOption()
      //
      //
      if (res && res.data && res.data.code === 200) {
        this.teamSizeOption = res.data.data
      }
    },
    // 团队规模
    SizeData(data) {
      const obj = this.teamSizeOption.find(
        (value, index, array) => value.no === data
      )
      if (obj) {
        return obj.name
      }
      // switch (Number(data)) {
      //   case 0:
      //     return "-";
      //   case 1:
      //     return "10-30人";
      //     break;
      //   case 2:
      //     return "30-50人";
      //     break;
      //   case 3:
      //     return "50-80人";
      //     break;
      //   case 4:
      //     return "80-100人";
      //     break;
      //   case 5:
      //     return "100人以上";
      //     break;
      //   default:
      //     break;
      // }
    },
    // 主营业务
    // ChangeToString(data, index) {
    //   if (data) {
    //     if (index == "left") {
    //       const array = data;

    //       const arrayIndex = [];
    //       array.map(item => {
    //         const stringData =
    //           `${item.firstCategoryName}` + "/" + `${item.secondCategoryName}`;
    //         arrayIndex.push(stringData);
    //       });
    //       return arrayIndex.join(",");
    //     } else {
    //       const array = JSON.parse(data);
    //       const arrayIndex = [];
    //       array.map(item => {
    //         const stringData =
    //           `${item.firstCategoryName}` + "/" + `${item.secondCategoryName}`;
    //         arrayIndex.push(stringData);
    //       });
    //       return arrayIndex.join(",");
    //     }
    //   } else {
    //     return null;
    //   }
    // },
    ChangeToString(data) {
      if (data) {
        // const array = JSON.parse(data);
        const array = data
        const arrayIndex = []
        array.map(item => {
          const stringData = `${
            item.firstCategoryName ? item.firstCategoryName : ""
          }${item.secondCategoryName ? "/" + item.secondCategoryName : ""}
          ${item.thirdCategoryName ? "/" + item.thirdCategoryName : ""}`
          arrayIndex.push(stringData)
        })
        return arrayIndex.join(" ; ")
      } else {
        return null
      }
    },
    // 获取报价详情
    async PriseInfoDetail(id) {
      let res = await apiResignAll.PriseInfoDetail(id)
      if (res && res.data && res.data.code === 200) {
        this.PriseDetails = res.data.data
      }
    },
    // 获得详情
    async TeamInfoDetail(id) {
      let res = await apiResignAll.TeamInfoDetail(id)
      if (res && res.data && res.data.code === 200) {
        Object.assign(this.messageData, res.data.data)
        // this.messageData.isCompany = 2;

        // //请求业绩

        // this.performanceParam.basicInfoNo = this.messageData.no;
        // this.getTeamResults(this.performanceParam);

        // //获得人员
        // this.performanceParamPerson.basicInfoNo = this.messageData.no;
        // this.getTeamPerson(this.performanceParamPerson);

        // //获得设备信息
        // this.equParam.basicInfoNo = this.messageData.no;
        // this.teamDetailEquipmentList(this.equParam);

        // //获得施工报价
        // this.offerParam.basicInfoNo = this.messageData.no;
        // this.getTeamOffer(this.offerParam);
        // 获取报价信息
        // this.PriseInfoDetail(this.messageData.no);
        // //团队推荐
        this.newSettledList(this.messageData.provinceNo, id)

        // //获取视频相册
        // this.GetfindAlbumByTeamNo(id);

        // if (
        //   this.messageData.equipments &&
        //   this.messageData.equipments.length > 0
        // ) {
        //   this.equTeamList = this.messageData.equipments;
        // } else {
        //   this.equnoTextData = true;
        // }

        // 获得证书
        // this.getCertList();
      }
    },

    // 获得施工报价
    async getTeamOffer(data) {
      let res = await apiResignAll.getTeamteamPrice(data)
      if (res && res.data && res.data.code === 200) {
        this.offerdataList = res.data.data.records
        if (this.offerdataList.length === 0) {
          this.offernoTextData = true
        } else {
          this.offernoTextData = false
        }
        this.$set(this.offerParam, "total", res.data.data.total)
      }
    },
    // 获得业绩
    async getTeamResults(data) {
      let res = await apiResignAll.getTeamResults(data)
      if (res && res.data && res.data.code === 200) {
        this.dataList = res.data.data.records
        if (this.dataList.length === 0) {
          this.noTextData = true
        } else {
          this.noTextData = false
        }
        this.$set(this.performanceParam, "total", res.data.data.total)
      }
    },

    // 获得人员
    async getTeamPerson(data) {
      let res = await apiResignAll.getTeamPerson(data)
      if (res && res.data && res.data.code === 200) {
        this.teamPersondataList = res.data.data.records
        if (this.teamPersondataList.length === 0) {
          this.noTextDataPerson = true
        } else {
          this.noTextDataPerson = false
        }
        this.$set(this.performanceParamPerson, "total", res.data.data.total)
      }
    },

    // 获取设备
    async teamDetailEquipmentList(data) {
      let res = await apiResignAll.getequipmentList(data)

      if (res && res.data && res.data.code === 200) {
        this.equTeamList = res.data.data.records
        if (this.equTeamList.length === 0) {
          this.equnoTextData = true
        } else {
          this.equnoTextData = false
        }
        this.$set(this.equParam, "total", res.data.data.total)
      }
    },

    // 获取证书
    async getCertList() {
      let res = await apiResignAll.getCertificateList()
      if (res && res.data && res.data.code === 200) {
        this.CertList = res.data.data.records
        if (this.CertList.length === 0) {
          this.CertnoTextData = true
        } else {
          this.CertnoTextData = false
        }
      }
    },

    // 在线咨询
    OnlineConsulting() {
      if (!this.$store.state.loginType) {
        this.loginIndex()
      }
    },
    //  查看联系方式
    ShowPhoneNumber() {
      if (this.$store.state.loginType) {
        this.showpNumber = true
      } else {
        this.loginIndex()
      }
    },
    loginIndex() {
      let data = {
        callBack: function() {
          this.$store.dispatch("setUser")
          this.pushThis()
        }.bind(this)
      }
      this.$_login(data)
    },
    formatDate,
    formatDate2,
    computedP() {
      let infobox = document.getElementsByClassName("p_content")
      Array.from(infobox).forEach(element => {
        if (element.offsetHeight < 93) {
          element.nextSibling.style.display = "none"
        } else {
          element.style.height = "96px"
        }
      })
    },
    hasClass(_classList, _className) {
      if (_classList.indexOf(_className) !== -1) {
        return true
      } else {
        return false
      }
    },
    targetOpen(e) {
      const currentTarget = e.currentTarget
      const child = currentTarget.parentNode.children
      const parent = currentTarget.parentNode
      const previous = currentTarget.parentNode.previousSibling
      if (this.hasClass(previous.className, "ellipsis4")) {
        previous.classList.remove("ellipsis4")
        previous.style.height = "auto"
        child[0].innerHTML = "点击收起"
        child[1].classList.remove("el-icon-caret-bottom")
        child[1].classList.add("el-icon-caret-top")
        parent.classList.add("isopen")
      } else {
        previous.classList.add("ellipsis4")
        previous.style.height = "96px"
        child[0].innerHTML = "点击展开"
        child[1].classList.remove("el-icon-caret-top")
        child[1].classList.add("el-icon-caret-bottom")
        parent.classList.remove("isopen")
      }
    },
    tel(telNum) {
      if (telNum) {
        let ary = telNum.split("")
        ary.splice(3, 4, "****")
        return ary.join("")
      }
      return ""
    },
    checkContactway() {
      if (this.$store.state.loginType) {
        this.constructionTeamData.concatPhone = this.phone
      } else {
        link.login()
        //   this.$confirm('当前未登录, 是否跳转到登录页面?', '提示', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning'
        //   }).then(() => {
        //     window.location.href = process.env.VUE_APP_DOMAIN +'/login'
        //   })
      }
    }
  },
  watch: {
    CertList(n, o) {
      if (n && n.length > 0) {
        n.map(idx => {
          if (idx.type === 1) {
            // 图片
            const array = []
            array.push(idx.url)
            idx.picturePicData = array
          } else if (idx.type === 2) {
            // 视频
            idx.pictureVideoData = idx.url
          }
        })
        //
      }
    },
    equTeamList(n, o) {
      //
      n.map(item => {
        //
        if (typeof item.picture === "string") {
          item.picture = item.picture.split(",")
        }
      })
    },
    "messageData.teamIntroduce": {
      handler() {},
      deep: true
    },
    checkIndex: {
      handler(newValue) {},
      deep: true
    }
  },
  async mounted() {},
  destroyed() {}
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "~@/styles/variable.scss";
.bgdf {
  background: #dfe4ea;
}
.talents {
  width: 100%;
  background: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  &_details {
    width: 1200px;
    background: #f5f5f5;
    &_content {
      width: 1200px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      &_left {
        .titleTop {
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: white;

          padding: 20px 20px;
          border-bottom: 1px solid #f1f1f1;
          .left {
            padding: 0 10px;
            border-left: 3px solid #0286df;
          }
          .right {
            color: #0099ff;
            margin-left: 14px;
            text-decoration: underline;
            cursor: pointer;
          }
        }
        .equInfoDeatils {
          width: 100%;
          width: 880px;
          background: white;
          &_Content {
            width: 100%;
            padding-bottom: 30px;
            .title {
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(0, 0, 0, 1);
              line-height: 20px;
              padding: 20px;
            }
            .titleText {
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: rgba(0, 0, 0, 1);
              line-height: 20px;
              padding: 30px 20px;
              // margin: 30px 0;
            }
            .itemBox {
              // width: 100%;
              padding: 10px 20px;
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              > div {
                width: 45%;
                color: #666;
                span {
                  color: #333;
                }
              }
            }
            .titleType {
              margin-top: 20px;
              padding: 0 20px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              line-height: 20px;
            }
            .titleBorder {
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(2, 134, 223, 1);
              line-height: 24px;
              color: #0286df;
              padding: 20px;
              > div {
                border-left: 3px solid #0286df;
                padding-left: 10px;
                // padding-bottom: 10px;
                // border-bottom: 1px solid rgba(228, 231, 237, 1);
              }
            }
            .des {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
              line-height: 23px;
              padding: 0 20px;
              > div {
                padding: 20px 0;
                border-top: 1px solid rgba(228, 231, 237, 1);
              }
              .text {
                margin-bottom: 30px;
                display: -webkit-box;
                overflow: hidden;
                -webkit-line-clamp: 5;
                -webkit-box-orient: vertical;
              }

              .actionShow {
                display: -webkit-box;
                overflow: hidden;
                -webkit-line-clamp: 100;
                -webkit-box-orient: vertical;
              }
              .optionShow {
                //  margin-bottom: 30px;
                .showUp {
                  color: #0286df;
                  cursor: pointer;
                }
                .showDown {
                  color: #ff6600;
                  cursor: pointer;
                }
              }
            }
            .imgBox {
              padding: 0 20px;
              > div {
                padding: 20px 0;
                border-top: 1px solid rgba(228, 231, 237, 1);
                img {
                  width: 216px;
                  height: 140px;
                  display: inline-block;
                  margin: 0 20px 20px 0;
                }
              }
            }
            &_form {
              padding: 10px 20px 0;
              .upLoadBox {
                width: 148px;
                height: 148px;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                span {
                  display: inline-block;
                  line-height: 24px;
                }
              }
              .showImgBox {
                width: 486px;
                display: inline-block;
                border: 1px solid red;
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;
                position: relative;
                margin-top: 10px;
                // top: -151px;
                // z-index: 1;
                .icon {
                  display: inline-block;
                  width: 142px;
                  height: 142px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  margin: 0 20px 20px 0;
                }
                .showImg {
                  display: inline-block;
                  width: 140px;
                  height: 140px;
                  border: 1px solid blue;
                  margin: 0 20px 20px 0;
                }
              }

              .el-form--inline .el-form-item .serveAddress {
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                flex-wrap: wrap;
                .el-tag {
                  height: 40px;
                  color: #666;
                  margin: 0 5px 5px 5px;
                  padding: 6px;
                  min-width: 75px;
                  font-size: 14px;
                  line-height: 26px;
                  user-select: none;
                  text-align: center;
                  background-color: #fff;
                  font-family: PingFangSC-Regular;
                  .el-icon-close {
                    border-radius: 50%;
                    text-align: center;
                    position: relative;
                    cursor: pointer;
                    font-size: 12px;
                    height: 16px;
                    width: 16px;
                    line-height: 16px;
                    vertical-align: middle;
                    top: -1px;
                    right: 2px;
                  }
                }
              }
            }
            &_table {
              padding: 0 20px;
              min-height: 300px;
            }
          }
        }
      }
      &_right {
        width: 300px;
        margin-left: 20px;
        .PersonMessage {
          padding: 10px 20px;
          background: white;
          box-shadow: 0 2px 5px #e1e1e1;
          border-bottom: 1px solid #e4e7ed;
          margin-bottom: 10px;
          .name {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(0, 0, 0, 1);
            line-height: 36px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .describe {
              display: inline-block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 200px;
            }
            .text {
              display: inline-block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 200px;
            }
            .icon {
              display: inline-block;
              background: rgba(2, 134, 223, 1);
              border-radius: 4px;
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              line-height: 21px;
              margin-left: 20px;
              padding: 0px 6px;
            }
          }
          .imgIcon {
            img {
              display: inline-block;
              // width: 10px;
              // height: 10px;
              // border: 1px solid #999;
              margin-right: 15px;
            }
          }
          .item {
            font-size: 14px;
            line-height: 30px;
            span.showText {
              color: #0099ff;
              margin-left: 14px;
              text-decoration: underline;
              cursor: pointer;
            }
          }
          .box {
            // margin: 10px 0 20px;
            border: 1px solid #0099ff;
            color: #0099ff;
            width: 80px;
            font-size: 14px;
            // text-align: center;
            padding: 8px 15px;
            border-radius: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 15px auto;
            img {
              margin-right: 5px;
            }
            cursor: pointer;
          }
        }
        .EnterpriseMessage {
          padding: 10px 20px;
          background: white;
          box-shadow: 0 2px 5px #e1e1e1;
          border-bottom: 1px solid #e4e7ed;
          margin-bottom: 10px;
          .name {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(0, 0, 0, 1);
            line-height: 36px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .describe {
              display: inline-block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 200px;
            }
            .text {
              display: inline-block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 200px;
            }
            .icon {
              display: inline-block;
              background: rgba(2, 134, 223, 1);
              border-radius: 4px;
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              line-height: 21px;
              margin-left: 20px;
              padding: 0px 6px;
            }
          }
          .imgIcon {
            img {
              display: inline-block;
              // width: 10px;
              // height: 10px;
              // border: 1px solid #999;
              margin-right: 15px;
            }
          }
          .item {
            font-size: 12px;
            line-height: 30px;
            span.showText {
              color: #0099ff;
              margin-left: 14px;
              text-decoration: underline;
              cursor: pointer;
            }
          }
          .footer {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .textLeft {
              cursor: pointer;
              background: #0099ff;
              color: white;
              width: 80px;
              font-size: 14px;
              // text-align: center;
              padding: 5px 5px;
              border-radius: 5px;
              display: flex;
              justify-content: center;
              align-items: center;
              margin: 15px auto;
              margin: 15px 10px 15px auto;
            }
            .box {
              // margin: 10px 0 20px;
              border: 1px solid #0099ff;
              color: #0099ff;
              width: 80px;
              font-size: 14px;
              // text-align: center;
              padding: 5px 5px;
              border-radius: 5px;
              display: flex;
              justify-content: center;
              align-items: center;
              margin: 15px auto;
              margin: 15px 15px auto 10px;
              img {
                margin-right: 5px;
              }
              cursor: pointer;
            }
          }
        }
        .ImgContent {
          width: 300px;
          height: 100px;
          // margin: 10px 0;
          margin-bottom: 10px;
          border: 1px solid #ccc;
        }
        .dataList {
          width: 260px;
          padding: 20px;
          background: white;
          margin-bottom: 30px;
          > .title {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .name {
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(2, 134, 223, 1);
              line-height: 30px;
              border-left: 3px solid #0286df;
              padding-left: 10px;
            }
            .more {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
              line-height: 36px;
              cursor: pointer;
            }
          }
          .itemList {
            padding: 10px 0px;
            .item {
              border: 1px solid rgba(228, 230, 237, 1);
              font-size: 12px;
              color: #999;
              line-height: 30px;
              margin-bottom: 20px;
              .top {
                padding: 10px 8px;
                // height: 90px;
                max-height: 90px;
                background: rgba(245, 247, 250, 1);
                .title {
                  color: #000;
                  font-size: 14px;
                  font-weight: 300;
                  cursor: pointer;
                }
              }
              .bottom {
                padding: 10px 8px 0 8px;
                height: 90px;
                // height: 70px;
                .type {
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                .business {
                  line-height: 30px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }
              span {
                color: #333;
              }
            }
          }
          .noList {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 275px;
          }
          // .more {
          //   font-size: 12px;
          //   color: #999;
          //   text-align: right;
          //   margin: 10px 20px 30px;
          //   cursor: pointer;
          // }
        }
      }
    }
  }
}

.noData {
  width: 100%;
  margin-bottom: 50px;
  background: #ffffff;
  padding-bottom: 40px;
  padding-top: 50px;
  border-radius: 0 0 4px 4px;
  border-top: none;
  box-sizing: border-box;
  .noDataImg {
    width: 177px;
    margin: 0 auto 15px;
    img {
      width: 100%;
    }
  }
  .noText {
    text-align: center;
    font-size: 18px;
    color: #333;
  }
}
</style>
<style lang="scss" rel="stylesheet/scss">
.changeTootip {
  border: 1px solid #767676 !important;
  padding: 4px !important;
  font-size: 12px !important;
  font-family: Microsoft YaHei;
  // font-weight: 300 !important;
  color: rgba(102, 102, 102, 1) !important;
  border-radius: 2px !important;
  max-width: 1200px !important;
}
</style>
